import { React, useState } from "react";
import { NavLink } from "react-router-dom";
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";

function Mobile_menu() {
  const [menu, setMenu] = useState(false);

  const openMenu = () => {
    if (!menu) {
      setMenu(true);
      document.getElementById("mobile-menu").classList.add("active");
    } else {
      setMenu(false);
      document.getElementById("mobile-menu").classList.remove("active");
    }
  };
  return (
    <div className="col-2 d-block d-lg-none mobile-menu">
      <a onClick={openMenu}>
        {!menu ? (
          <IoMdMenu size={25} color="white" />
        ) : (
          <IoMdClose size={25} color="white" />
        )}
      </a>
      <ul className="d-flex d-lg-none" id="mobile-menu">
        <li>
          <NavLink to="/">صفحه اصلی</NavLink>
        </li>
        <li>
          <NavLink to="blog">وبلاگ</NavLink>
        </li>
        <li className="has-children">
          <NavLink to="menu">منو</NavLink>
        </li>
        <li>
          <NavLink to="contact-us">تماس با ما</NavLink>
        </li>
        <li>
          <NavLink to="about-us">درباره ما</NavLink>
        </li>
        <li>
          <a href="https://baghban.restaurant/extra/360/" target="_blank">
            تور مجازی
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Mobile_menu;
